// CompleteProfileDialog.jsx
import React, { useState, useEffect, useRef } from "react";

export default function CompleteProfileDialog({
  open,
  userData,
  emailMismatch,
  onSubmit,
}) {
  const [name, setName] = useState(userData?.name || "");
  const [phone, setPhone] = useState(userData?.phone || "");
  const [email, setEmail] = useState(userData?.email || "");
  const [touched, setTouched] = useState(false);
  const [errors, setErrors] = useState({});
  const originalEmailRef = useRef(userData?.email || "");

  // Reset fields when dialog opens, and store the original email
  useEffect(() => {
    if (open) {
      setName(userData?.name || "");
      setPhone(userData?.phone || "");
      setEmail(userData?.email || "");
      setTouched(false);
      setErrors({});
      originalEmailRef.current = userData?.email || "";
    }
  }, [open, userData]);

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email))
      newErrors.email = "Valid email is required.";
    if (!/^\+?\d{10,15}$/.test(phone))
      newErrors.phone = "Enter a valid phone number.";
    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    setTouched(true);

    if (Object.keys(validationErrors).length === 0) {
      onSubmit({ name, phone, email });

      // If the email was changed, show message then force logout
      if (email !== originalEmailRef.current) {
        alert("Please use your new email to login");
        window.location.href = "/login";
      }
    }
  };

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#1e2235",
          color: "#fff",
          padding: 28,
          borderRadius: 16,
          width: "90%",
          maxWidth: 420,
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
        }}
      >
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>
          📝 Complete Your Profile
        </h2>

        {emailMismatch && (
          <div
            style={{
              background: "#fde68a",
              color: "#92400e",
              padding: "10px 14px",
              borderRadius: 6,
              fontSize: 14,
              marginBottom: 14,
            }}
          >
            ⚠️ Your login email was different. We've updated it to match.
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <label>
            <div style={{ fontSize: 14, marginBottom: 4 }}>Email *</div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              style={{
                background: "#2e344a",
                border: "1px solid #3b4260",
                color: "#fff",
                padding: 10,
                borderRadius: 6,
                width: "100%",
              }}
            />
            {touched && errors.email && (
              <div style={{ fontSize: 13, color: "#f87171" }}>
                {errors.email}
              </div>
            )}
          </label>

          <label>
            <div style={{ fontSize: 14, marginBottom: 4 }}>Name *</div>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your full name"
              style={{
                background: "#2e344a",
                border: "1px solid #3b4260",
                color: "#fff",
                padding: 10,
                borderRadius: 6,
                width: "100%",
              }}
            />
            {touched && errors.name && (
              <div style={{ fontSize: 13, color: "#f87171" }}>
                {errors.name}
              </div>
            )}
          </label>

          <label>
            <div style={{ fontSize: 14, marginBottom: 4 }}>Phone Number *</div>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+447XXXXXXXXX"
              style={{
                background: "#2e344a",
                border: "1px solid #3b4260",
                color: "#fff",
                padding: 10,
                borderRadius: 6,
                width: "100%",
              }}
            />
            {touched && errors.phone && (
              <div style={{ fontSize: 13, color: "#f87171" }}>
                {errors.phone}
              </div>
            )}
          </label>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 20,
          }}
        >
          <button
            onClick={handleSubmit}
            style={{
              background: "#3b82f6",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: 6,
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
